module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_2_ES-d65dd7ee178087bd52b8a7d6d278ebc7.svg";